<template>
  <v-card outlined>
    <v-card-title>
      Виды деятельности
    </v-card-title>
    <v-toolbar dense flat>
      <v-dialog v-model="editor" max-width="480">
        <template #activator="{ on, attr }">
          <v-row align="center">
            <v-col cols="6">
              <v-btn
                text
                color="primary"
                v-bind="attr"
                v-on="on"
                :disabled="!availableAdd"
              >
                <v-icon left>mdi-plus</v-icon>
                <span>Добавить</span>
              </v-btn>
            </v-col>
          </v-row>
        </template>
        <rating-activity-type-editor
          v-model="item"
          :activityTypes="activityTypes"
          :availableTypes="availableActivityTypes"
          @close="close"
          @save="save"
        />
      </v-dialog>
    </v-toolbar>
    <v-data-table
      dense
      :headers="headers"
      :items="items"
      :loading="loading"
      item-key="id"
      @click:row="open"
      hide-default-footer
    >
      <template v-slot:item.actions="{ item }">
        <deleting-dialog
          :data="item"
          title="Удаление"
          :message="itemRemoveMessage(item)"
          @delete-request="deleteItem"
        />
      </template>
      <template v-slot:item.points="{ item }">
        {{ item.minPoints }} - {{ item.maxPoints }}
      </template>
      <template v-slot:item.sum="{ item }">
        {{ rub.format(item.sum) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import {
  getActivityTypeInfoByRating,
  createRatingActivityType,
  updateRatingActivityType,
  deleteRatingActivityType
} from "../../services/rating.service";

import RatingActivityTypeEditor from "./RatingActivityTypeEditor.vue";
import DeletingDialog from "../DeletingDialog.vue";

export default {
  name: "RatingActivityTypeList",

  props: {
    rating: { type: Object, required: true },
    activityTypes: { type: Array, default: () => [] }
  },

  components: { RatingActivityTypeEditor, DeletingDialog },

  computed: {
    availableActivityTypes() {
      return this.activityTypes.filter(
        type => !this.items.some(i => i.typeId == type.id)
      );
    },
    availableAdd() {
      return this.availableActivityTypes.length > 0;
    }
  },

  data() {
    return {
      rub: Intl.NumberFormat("ru-RU", {
        style: "currency",
        currency: "RUB",
        currencyDisplay: "symbol"
      }),
      headers: [
        { text: "Вид деятельности", value: "typeName" },
        { text: "Коэффициент", value: "index" },
        { text: "Количество утвержденных заявок", value: "requestCount" },
        { text: "Баллы (min - max)", value: "points" },
        { text: "Сумма утвержденных", value: "sum" },
        { text: "Действия", value: "actions" }
      ],
      items: [],
      item: {},

      search: null,
      loading: false,
      editor: false,

      globalSearch: ""
    };
  },

  watch: {
    rating: {
      handler(v) {
        this.load();
      },
      immediate: true
    },

    editor(opened) {
      if (!opened) this.item = {};
    }
  },

  methods: {
    async load() {
      if (this.rating.id) {
        try {
          this.loading = true;
          this.items = await getActivityTypeInfoByRating(this.rating.id);
        } catch (e) {
          this.$notify({
            text: e.response ? e.response.data.message : e,
            type: "error"
          });
        } finally {
          this.loading = false;
        }
      } else {
        this.items = [];
      }
    },
    async deleteItem(item) {
      try {
        await deleteRatingActivityType(item.id);
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      } finally {
        this.$emit("update");
      }
    },

    itemRemoveMessage(rmItem) {
      return `Удалить: ${rmItem.typeName} деятельность?`;
    },

    open(item) {
      this.item = item;
      this.editor = true;
    },

    close() {
      this.editor = false;
    },

    async save(ratingType) {
      try {
        if (!ratingType.id) {
          await createRatingActivityType(this.rating.id, ratingType);
        } else {
          await updateRatingActivityType(ratingType.id, ratingType);
        }
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      } finally {
        this.$emit("update");
      }
    }
  }
};
</script>
